import { render, staticRenderFns } from "./Dictaphone.vue?vue&type=template&id=713002b8"
import script from "./Dictaphone.vue?vue&type=script&lang=js"
export * from "./Dictaphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports